import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";

const antIcon = <LoadingOutlined style={{ fontSize: "2rem" }} spin />;

const Spinner = ({ spinning = true, style, display }) => {
  return (
    <div style={{ display: display === "inline" ? "inline" : "block" }}>
      <Spin spinning={spinning} indicator={antIcon} style={style} />
    </div>
  );
};

export default Spinner;
